/**
 * Variant Finger Size Dropdown
 * Updates finger size dropdown options when variants change
 */
(function() {
  'use strict';
  
  // Initialize all finger size selects
  function initializeFingerSizeSelects() {
    const ringSizeDataScripts = document.querySelectorAll('script[data-variant-ring-size]');
    
    ringSizeDataScripts.forEach(ringSizeDataScript => {
      const selectId = ringSizeDataScript.getAttribute('data-select-id');
      if (!selectId) return;
      
      const selectElement = document.getElementById(selectId);
      if (!selectElement) return;
      
      // Only initialize once per select
      if (selectElement.dataset.fingerSizeInitialized) return;
      selectElement.dataset.fingerSizeInitialized = 'true';
      
      // Create update function for this specific select
      function updateFingerSizeOptions(event) {
        const ringSizeDataScript = document.querySelector('script[data-variant-ring-size][data-select-id="' + selectId + '"]');
        if (!ringSizeDataScript) return;
        
        let variantRingSizeData = {};
        try {
          variantRingSizeData = JSON.parse(ringSizeDataScript.textContent);
        } catch (e) {
          console.error('Error parsing variant ring size data:', e);
          return;
        }
        
        const variantId = event.detail?.variant?.id;
        if (!variantId) return;
        
        const ringSizeValue = variantRingSizeData[variantId];
        if (!ringSizeValue) return;
        
        // Parse the ring size values (comma-separated)
        const ringSizes = typeof ringSizeValue === 'string' ? ringSizeValue.split(',').map(s => s.trim()) : [];
        
        // Update the native select options
        const select = document.getElementById(selectId);
        if (!select) return;
        
        // Clear existing options (except first empty option if required)
        const firstOption = select.querySelector('option[value=""]');
        select.innerHTML = '';
        if (firstOption) {
          select.appendChild(firstOption);
        }
        
        // Add new options
        ringSizes.forEach(size => {
          if (size) {
            const option = document.createElement('option');
            option.value = size;
            option.textContent = size;
            select.appendChild(option);
          }
        });
        
        // Select first available option instead of placeholder
        let firstAvailableOption = null;
        if (select.options.length > 0) {
          // Skip empty placeholder option if it exists
          firstAvailableOption = firstOption && select.options.length > 1 ? select.options[1] : select.options[0];
          if (firstAvailableOption && firstAvailableOption.value !== '') {
            firstAvailableOption.selected = true;
          } else if (select.options.length > 0) {
            select.options[0].selected = true;
            firstAvailableOption = select.options[0];
          }
        }
        
        // Update the custom UI
        const customUI = select.closest('.form-control')?.querySelector('.custom-select-ui');
        if (customUI) {
          const selectedOption = customUI.querySelector('.selected-option');
          const optionsContainer = customUI.querySelector('.select-options');
          const container = select.closest('.form-control');
          
          if (selectedOption && firstAvailableOption && firstAvailableOption.value !== '') {
            // Show first available option value instead of placeholder
            selectedOption.textContent = firstAvailableOption.textContent;
            selectedOption.classList.remove('placeholder');
            if (container) {
              container.classList.add('has-value');
            }
            // Trigger change event for the auto-selected value
            const changeEvent = new Event('change', { bubbles: true });
            select.dispatchEvent(changeEvent);
          } else if (selectedOption) {
            // Fallback to placeholder if no options
            const labelElement = customUI.closest('.form-control')?.querySelector('label');
            const labelText = labelElement ? labelElement.textContent : 'Finger Size';
            selectedOption.textContent = labelText;
            selectedOption.classList.add('placeholder');
            if (container) {
              container.classList.remove('has-value');
            }
          }
          
          if (optionsContainer) {
            optionsContainer.innerHTML = '';
            ringSizes.forEach((size, index) => {
              if (size) {
                const optionDiv = document.createElement('div');
                optionDiv.className = 'select-option';
                optionDiv.setAttribute('data-value', size);
                optionDiv.textContent = size;
                
                // Mark first option as selected
                if (index === 0 && firstAvailableOption && firstAvailableOption.value === size) {
                  optionDiv.setAttribute('data-selected', 'true');
                }
                
                optionsContainer.appendChild(optionDiv);
                
                // Re-attach click handler for the new option
                optionDiv.addEventListener('click', function(e) {
                  e.stopPropagation();
                  
                  const value = this.getAttribute('data-value');
                  if (selectedOption) {
                    selectedOption.textContent = this.textContent;
                    selectedOption.classList.remove('placeholder');
                  }
                  
                  // Update the hidden select element
                  for (let i = 0; i < select.options.length; i++) {
                    if (select.options[i].value === value) {
                      select.selectedIndex = i;
                      break;
                    }
                  }
                  
                  // Mark as selected
                  optionsContainer.querySelectorAll('.select-option').forEach(opt => {
                    opt.removeAttribute('data-selected');
                  });
                  this.setAttribute('data-selected', 'true');
                  
                  // Also mark the corresponding option in native select if it exists
                  const nativeOption = Array.from(select.options).find(opt => opt.value === value);
                  if (nativeOption) {
                    nativeOption.selected = true;
                  }
                  
                  // Update container state
                  const container = select.closest('.form-control');
                  if (container) {
                    container.classList.add('has-value');
                  }
                  
                  // Trigger change event on the hidden select
                  const changeEvent = new Event('change', { bubbles: true });
                  select.dispatchEvent(changeEvent);
                  
                  // Close dropdown after selection
                  customUI.classList.remove('active');
                });
              }
            });
          }
        }
      }
      
      // Listen for variant changes
      document.addEventListener('variant:change', updateFingerSizeOptions);
      document.addEventListener('variant:changed', updateFingerSizeOptions);
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFingerSizeSelects);
  } else {
    initializeFingerSizeSelects();
  }
  
  // Re-initialize after product rerender (for AJAX updates)
  document.addEventListener('product:rerender', function() {
    setTimeout(initializeFingerSizeSelects, 100);
  });
})();

